import { render, staticRenderFns } from "./userCourse.vue?vue&type=template&id=6f67ceb2&"
import script from "./userCourse.vue?vue&type=script&lang=js&"
export * from "./userCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports